import { inject, type InjectionKey } from "vue";

export function injectStrict<T>(key: InjectionKey<T> | string, fallback?: T) {
  const resolved = inject(key, fallback);
  if (!resolved) {
    if (typeof key === "string") {
      throw new Error(`Could not resolve ${key}`);
    }
    throw new Error(`Could not resolve ${key.description}`);
  }
  return resolved;
}
